<template>
  <div class="container">
        登录
   
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      
    }
  },
  methods: {
    
  },
}
</script>

<style scoped>
  .container {}
</style>
